import React, { useState } from 'react'
import { GatsbyImage } from "gatsby-plugin-image";
import * as styles from './productTile.module.css'
import Check from '../../../static/checkmark.png'

const ProductTile = ({
  productIcon,
  productDesc,
  productName,
  productLabel,
  selected,
  maxAllowed,
  newSelection,
  onSelect,
  onDeselect,
  productColor,
  hideSelectedIndicator,
}) => {
  const isMobile = typeof window !== `undefined` && window.innerWidth <= 767
  return (
    <div
      className={`${styles.tile} ${
        newSelection.length < maxAllowed ? styles.allowed : styles.notAllowed
      }`}
      style={{
        backgroundColor: selected ? '#fff' : productColor,
        border: 'thin solid ' + productColor,
      }}
      onClick={() => {
        selected ? onDeselect() : onSelect()
      }}
    >
      {!isMobile && (
        <img src={productIcon} className={styles.icon} alt={productDesc} />
      )}
      <div className={styles.info}>
        <div
          className={styles.name}
          style={{ color: selected ? productColor : '#fff' }}
        >
          {productName}
        </div>
        <div
          className={styles.label}
          style={{ color: selected ? productColor : '#fff' }}
        >
          {productLabel}
        </div>
      </div>

      {selected && hideSelectedIndicator != true && (
        <div className={styles.checkMarkContainer}>
          <img src={Check} className={styles.checkMark} alt="check mark" />
        </div>
      )}
    </div>
  )
}

export default ProductTile
